import React from 'react';
import {connect} from 'react-redux';
import {Nav, Logo} from './styles';

class Navbar extends React.Component {
  renderLogo() {
    return (
      <Logo src={this.props.logo} alt="Logo" />
    );
  }

  renderTitle() {
    const {title} = this.props;

    if (title) {
      return (
        <span className="navbar-text">
          {title}
        </span>
      );
    }

    return null;
  }

  render() {
    return (
      <Nav className="navbar navbar-dark">
        <a href="/" className="navbar-brand">
          {this.renderLogo()}
        </a>

        {this.renderTitle()}
      </Nav>
    );
  }
}

const mapStateToProps = state => ({
  title: state.page.title,
  logo: state.page.logo
});

export default connect(mapStateToProps, null)(Navbar);